

/**
 * MVP Command Set — shown in the Suggestion Panel of the AI Command Bar.
 *
 * ⚡ Commands   – Universal, can escalate to AI when needed
 * 🛡 Compliance – Deterministic, never hit AI
 * 📜 Policies   – Deterministic, never hit AI
 *
 * Each item has:
 *  label  – display text
 *  query  – injected into the command bar when clicked
 *  hint   – optional tooltip description
 */
export const AI_SUGGESTIONS = [
    {
        category: 'Commands',
        label: '⚡ Commands',
        color: '#7c3aed',
        items: [
            {
                label: '/search',
                query: '/search ',
                hint: 'Find policies, controls, or reports',
            },
            {
                label: '/summarize',
                query: '/summarize ',
                hint: 'Summarize a policy, control, or evidence (uses AI)',
            },
            {
                label: '/draft',
                query: '/draft ',
                hint: 'Draft a new policy or document (uses AI)',
            },
        ],
    },
    {
        category: 'Compliance',
        label: '🛡 Compliance',
        color: '#059669',
        items: [
            {
                label: '/readiness',
                query: '/readiness',
                hint: 'Show framework readiness — e.g. /readiness CMMC L1',
            },
            {
                label: '/gaps',
                query: '/gaps',
                hint: 'Show missing controls / evidence gaps',
            },
            {
                label: '/report',
                query: '/report',
                hint: 'Generate a compliance report — e.g. /report CMMC L1',
            },
        ],
    },
    {
        category: 'Policies',
        label: '📜 Policies',
        color: '#2563eb',
        items: [
            {
                label: '/policies',
                query: '/policies ',
                hint: 'List or search policies — e.g. /policies access control',
            },
            {
                label: '/policy',
                query: '/policy ',
                hint: 'Open or summarize a policy — e.g. /policy Acceptable Use Policy',
            },
        ],
    },
];

/**
 * Example queries shown as quick-fill chips.
 * These are contextual examples to help users discover the command set.
 */
export const EXAMPLE_QUERIES = [
    '/readiness CMMC L1',
    '/gaps CMMC L2',
    '/report CMMC L1',
    '/policies access control',
    '/policy Acceptable Use Policy',
    '/summarize access control policy',
    '/draft media protection policy for CMMC',
];

// Backward-compat shim if anything still references SLASH_COMMANDS
export const SLASH_COMMANDS = AI_SUGGESTIONS[0].items.map(item => ({ cmd: item.label }));
